import { TransitionsReport } from "./TransitionsReport";
export default TransitionsReport;
